import { RoleEnum } from '@enum/role.enum';
import { ApplicationInterface } from '@interface/application/application.interface';

export const initialNewApplicationForm: Omit<ApplicationInterface, 'id'> = {
  account: {
    id: '',
  },
  name: '',
  role: RoleEnum.User,
  webhookSecret: '',
};
